module.exports = __webpack_public_path__ + "img/ewide-logo.f66e5f0e.png";